// frontend/src/msalConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "<FRONTEND_CLIENT_ID>",
    // "common" = multi-tenant: users sign in with a work/school account from ANY Entra
    // tenant, or a personal Microsoft account. Set REACT_APP_AZURE_AUTHORITY to
    // "organizations" to exclude personal accounts, or to a tenant GUID to pin sign-in
    // back to one tenant. Must match the backend's AZURE_AUTHORITY, which validates the
    // issuer of the tokens this authority mints.
    authority:
      `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AUTHORITY || "common"}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || (window.location.origin + "/loginNew"),
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || (window.location.origin + "/"),
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true, // Required for Azure App Services
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      logLevel: "Info",
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case "Error":
            console.error(message);
            return;
          case "Info":
            console.info(message);
            return;
          case "Verbose":
            console.debug(message);
            return;
          case "Warning":
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// scopes used when requesting an access token for the backend API
export const loginRequest = {
  scopes: [process.env.REACT_APP_AZURE_API_SCOPE || "api://<BACKEND_CLIENT_ID>/access_as_user"]
};
